import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _11399f99 = () => interopDefault(import('../pages/bilpop/index.vue' /* webpackChunkName: "pages/bilpop/index" */))
const _ce2b555c = () => interopDefault(import('../pages/cerez-politikasi/index.vue' /* webpackChunkName: "pages/cerez-politikasi/index" */))
const _5651ac6b = () => interopDefault(import('../pages/kurumsal/index.vue' /* webpackChunkName: "pages/kurumsal/index" */))
const _7567f6ae = () => interopDefault(import('../pages/kurumsal/index/index.vue' /* webpackChunkName: "pages/kurumsal/index/index" */))
const _6b11f13f = () => interopDefault(import('../pages/kurumsal/index/hakkimizda.vue' /* webpackChunkName: "pages/kurumsal/index/hakkimizda" */))
const _6a0241d6 = () => interopDefault(import('../pages/kurumsal/index/kariyer.vue' /* webpackChunkName: "pages/kurumsal/index/kariyer" */))
const _72f44c4a = () => interopDefault(import('../pages/kurumsal/index/topluluk-kurallari.vue' /* webpackChunkName: "pages/kurumsal/index/topluluk-kurallari" */))
const _3d0353b4 = () => interopDefault(import('../pages/kurumsal/index/iletisim.vue' /* webpackChunkName: "pages/kurumsal/index/iletisim" */))
const _b1a6e5a8 = () => interopDefault(import('../pages/kurumsal/index/kunye.vue' /* webpackChunkName: "pages/kurumsal/index/kunye" */))
const _3b3b3126 = () => interopDefault(import('../pages/kurumsal/index/gizlilik-politikasi.vue' /* webpackChunkName: "pages/kurumsal/index/gizlilik-politikasi" */))
const _949d43d0 = () => interopDefault(import('../pages/kurumsal/index/yayin-ilkeleri.vue' /* webpackChunkName: "pages/kurumsal/index/yayin-ilkeleri" */))
const _8d0f2c5a = () => interopDefault(import('../pages/kurumsal/index/kullanici-sozlesmesi.vue' /* webpackChunkName: "pages/kurumsal/index/kullanici-sozlesmesi" */))
const _fb14c2f0 = () => interopDefault(import('../pages/emojile/index.vue' /* webpackChunkName: "pages/emojile/index" */))
const _eeebcba0 = () => interopDefault(import('../pages/oyun/index.vue' /* webpackChunkName: "pages/oyun/index" */))
const _7a815b09 = () => interopDefault(import('../pages/kesfet/index.vue' /* webpackChunkName: "pages/kesfet/index" */))
const _826bda66 = () => interopDefault(import('../pages/mesaj/index.vue' /* webpackChunkName: "pages/mesaj/index" */))
const _2f01bfd6 = () => interopDefault(import('../pages/bildirimler/index.vue' /* webpackChunkName: "pages/bildirimler/index" */))
const _fcbd9d0a = () => interopDefault(import('../pages/r/index.vue' /* webpackChunkName: "pages/r/index" */))
const _34850b58 = () => interopDefault(import('../pages/rss.vue' /* webpackChunkName: "pages/rss" */))
const _0a46f700 = () => interopDefault(import('../pages/sanaozel/index.vue' /* webpackChunkName: "pages/sanaozel/index" */))
const _646feb4e = () => interopDefault(import('../pages/ara/index.vue' /* webpackChunkName: "pages/ara/index" */))
const _03d1d2c6 = () => interopDefault(import('../pages/ayarlar/index.vue' /* webpackChunkName: "pages/ayarlar/index" */))
const _ec63496e = () => interopDefault(import('../pages/trendler/index.vue' /* webpackChunkName: "pages/trendler/index" */))
const _3364af31 = () => interopDefault(import('../pages/tumicerikler/index.vue' /* webpackChunkName: "pages/tumicerikler/index" */))
const _44a00943 = () => interopDefault(import('../pages/vitrin/index.vue' /* webpackChunkName: "pages/vitrin/index" */))
const _1935bda1 = () => interopDefault(import('../pages/yazio/index.vue' /* webpackChunkName: "pages/yazio/index" */))
const _4f2293c2 = () => interopDefault(import('../pages/zekiye/index.vue' /* webpackChunkName: "pages/zekiye/index" */))
const _0f75c1a8 = () => interopDefault(import('../pages/astroloji/burc-uyumu-hesaplama/index.vue' /* webpackChunkName: "pages/astroloji/burc-uyumu-hesaplama/index" */))
const _4e0343f0 = () => interopDefault(import('../pages/astroloji/dogum-haritasi-hesaplama/index.vue' /* webpackChunkName: "pages/astroloji/dogum-haritasi-hesaplama/index" */))
const _388f3e59 = () => interopDefault(import('../pages/astroloji/yukselen-burc-hesaplama/index.vue' /* webpackChunkName: "pages/astroloji/yukselen-burc-hesaplama/index" */))
const _9d410026 = () => interopDefault(import('../pages/aydinlatma-metni/calisan-adayi.vue' /* webpackChunkName: "pages/aydinlatma-metni/calisan-adayi" */))
const _3fb3d99c = () => interopDefault(import('../pages/aydinlatma-metni/fiziki-ziyaretci.vue' /* webpackChunkName: "pages/aydinlatma-metni/fiziki-ziyaretci" */))
const _1445949a = () => interopDefault(import('../pages/aydinlatma-metni/ilgili-kisi-basvuru-formu.vue' /* webpackChunkName: "pages/aydinlatma-metni/ilgili-kisi-basvuru-formu" */))
const _3019357b = () => interopDefault(import('../pages/aydinlatma-metni/musteri-adayi.vue' /* webpackChunkName: "pages/aydinlatma-metni/musteri-adayi" */))
const _2447d5ea = () => interopDefault(import('../pages/aydinlatma-metni/uye-ziyaretci.vue' /* webpackChunkName: "pages/aydinlatma-metni/uye-ziyaretci" */))
const _2249dd08 = () => interopDefault(import('../pages/dev/counter.vue' /* webpackChunkName: "pages/dev/counter" */))
const _27dd0703 = () => interopDefault(import('../pages/dev/reco.vue' /* webpackChunkName: "pages/dev/reco" */))
const _40a5bbca = () => interopDefault(import('../pages/haber/yarat.vue' /* webpackChunkName: "pages/haber/yarat" */))
const _26c0b582 = () => interopDefault(import('../pages/mobile/bilpop.vue' /* webpackChunkName: "pages/mobile/bilpop" */))
const _435cb13c = () => interopDefault(import('../pages/mobile/emojile.vue' /* webpackChunkName: "pages/mobile/emojile" */))
const _bc625412 = () => interopDefault(import('../pages/ayarlar/engellenen-hesaplar.vue' /* webpackChunkName: "pages/ayarlar/engellenen-hesaplar" */))
const _041c4ebc = () => interopDefault(import('../pages/ayarlar/sifre-degistir.vue' /* webpackChunkName: "pages/ayarlar/sifre-degistir" */))
const _f3fac482 = () => interopDefault(import('../pages/ayarlar/hesap-dondurma.vue' /* webpackChunkName: "pages/ayarlar/hesap-dondurma" */))
const _d2f0c71e = () => interopDefault(import('../pages/ayarlar/hesap-silme.vue' /* webpackChunkName: "pages/ayarlar/hesap-silme" */))
const _36afcdd6 = () => interopDefault(import('../pages/astroloji/dogum-haritasi-hesaplama/sonuc.vue' /* webpackChunkName: "pages/astroloji/dogum-haritasi-hesaplama/sonuc" */))
const _09696e1c = () => interopDefault(import('../pages/astroloji/tarot/tarot-kartlari-ve-anlamlari.vue' /* webpackChunkName: "pages/astroloji/tarot/tarot-kartlari-ve-anlamlari" */))
const _d37ea3b2 = () => interopDefault(import('../pages/astroloji/yukselen-burc-hesaplama/sonuc.vue' /* webpackChunkName: "pages/astroloji/yukselen-burc-hesaplama/sonuc" */))
const _89c8af24 = () => interopDefault(import('../pages/auth/twitter/callback.vue' /* webpackChunkName: "pages/auth/twitter/callback" */))
const _466469dc = () => interopDefault(import('../pages/embed/widget/leaderboard.vue' /* webpackChunkName: "pages/embed/widget/leaderboard" */))
const _304bc57f = () => interopDefault(import('../pages/mobile/oyun/leaderboard/_slug.vue' /* webpackChunkName: "pages/mobile/oyun/leaderboard/_slug" */))
const _6ddd5cbf = () => interopDefault(import('../pages/mobile/oyun/skor/_slug.vue' /* webpackChunkName: "pages/mobile/oyun/skor/_slug" */))
const _3db57f00 = () => interopDefault(import('../pages/astroloji/tarot/_slug/index.vue' /* webpackChunkName: "pages/astroloji/tarot/_slug/index" */))
const _21f42f93 = () => interopDefault(import('../pages/auth/delete-account/_slug.vue' /* webpackChunkName: "pages/auth/delete-account/_slug" */))
const _b0f27e7a = () => interopDefault(import('../pages/auth/forgot-password/_slug.vue' /* webpackChunkName: "pages/auth/forgot-password/_slug" */))
const _0bc6f761 = () => interopDefault(import('../pages/auth/reset-password/_slug.vue' /* webpackChunkName: "pages/auth/reset-password/_slug" */))
const _b7529c60 = () => interopDefault(import('../pages/auth/verify-email/_slug.vue' /* webpackChunkName: "pages/auth/verify-email/_slug" */))
const _547b82d2 = () => interopDefault(import('../modules/category/pages/categoryPage.vue' /* webpackChunkName: "CategoryPage" */))
const _0611b3d6 = () => interopDefault(import('../pages/oyun/leaderboard/_slug.vue' /* webpackChunkName: "pages/oyun/leaderboard/_slug" */))
const _c30a5b70 = () => interopDefault(import('../pages/oyun/skor/_slug.vue' /* webpackChunkName: "pages/oyun/skor/_slug" */))
const _c08fb810 = () => interopDefault(import('../pages/ara/haber/_slug.vue' /* webpackChunkName: "pages/ara/haber/_slug" */))
const _db0c8cf8 = () => interopDefault(import('../pages/ara/etiket/_slug.vue' /* webpackChunkName: "pages/ara/etiket/_slug" */))
const _3ffd4743 = () => interopDefault(import('../pages/ara/uye/_slug.vue' /* webpackChunkName: "pages/ara/uye/_slug" */))
const _72beb39d = () => interopDefault(import('../pages/astroloji/tarot/_slug/_card.vue' /* webpackChunkName: "pages/astroloji/tarot/_slug/_card" */))
const _3c773672 = () => interopDefault(import('../modules/tag/pages/TagPage.vue' /* webpackChunkName: "TagPage" */))
const _a4a8570e = () => interopDefault(import('../pages/akis/_slug.vue' /* webpackChunkName: "pages/akis/_slug" */))
const _80a200a4 = () => interopDefault(import('../pages/amp-haber/_slug.vue' /* webpackChunkName: "pages/amp-haber/_slug" */))
const _638bf4b7 = () => interopDefault(import('../pages/haber/_slug.vue' /* webpackChunkName: "pages/haber/_slug" */))
const _f2590e30 = () => interopDefault(import('../pages/oyun/_slug.vue' /* webpackChunkName: "pages/oyun/_slug" */))
const _a208d6ae = () => interopDefault(import('../pages/h/_slug.vue' /* webpackChunkName: "pages/h/_slug" */))
const _2a2b3973 = () => interopDefault(import('../pages/instagram/_slug.vue' /* webpackChunkName: "pages/instagram/_slug" */))
const _6264ec8f = () => interopDefault(import('../pages/profil/_username/index.vue' /* webpackChunkName: "pages/profil/_username/index" */))
const _0f3c3a60 = () => interopDefault(import('../pages/profil/_username/index/icerikler.vue' /* webpackChunkName: "pages/profil/_username/index/icerikler" */))
const _228c5d19 = () => interopDefault(import('../pages/profil/_username/index/yorumlar.vue' /* webpackChunkName: "pages/profil/_username/index/yorumlar" */))
const _eb22c564 = () => interopDefault(import('../pages/profil/_username/index/favoriler.vue' /* webpackChunkName: "pages/profil/_username/index/favoriler" */))
const _1170ecfe = () => interopDefault(import('../pages/profil/_username/index/takipciler.vue' /* webpackChunkName: "pages/profil/_username/index/takipciler" */))
const _5b304122 = () => interopDefault(import('../pages/profil/_username/index/takip-ettikleri.vue' /* webpackChunkName: "pages/profil/_username/index/takip-ettikleri" */))
const _67dd2dde = () => interopDefault(import('../pages/ara/_slug.vue' /* webpackChunkName: "pages/ara/_slug" */))
const _1087887c = () => interopDefault(import('../pages/uye/_slug.vue' /* webpackChunkName: "pages/uye/_slug" */))
const _177f1c59 = () => interopDefault(import('../pages/yazio/_slug.vue' /* webpackChunkName: "pages/yazio/_slug" */))
const _5778039d = () => interopDefault(import('../pages/mobile/_slug/view.vue' /* webpackChunkName: "pages/mobile/_slug/view" */))
const _cb375fde = () => interopDefault(import('../pages/profil/_username/ayarlar.vue' /* webpackChunkName: "pages/profil/_username/ayarlar" */))
const _2a849156 = () => interopDefault(import('../pages/astroloji/_burc/_slug.vue' /* webpackChunkName: "pages/astroloji/_burc/_slug" */))
const _3e48db2a = () => interopDefault(import('../pages/mesaj/_username/_slug.vue' /* webpackChunkName: "pages/mesaj/_username/_slug" */))
const _16ef6b7c = () => interopDefault(import('../pages/vitrin/_slug/_pageNum.vue' /* webpackChunkName: "pages/vitrin/_slug/_pageNum" */))
const _5c8fd7fd = () => interopDefault(import('../pages/etiket/_tagName/_tagId/_pageNum.vue' /* webpackChunkName: "pages/etiket/_tagName/_tagId/_pageNum" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/bilpop",
    component: _11399f99,
    name: "bilpop___en"
  }, {
    path: "/cookie-policy",
    component: _ce2b555c,
    name: "cerez-politikasi___en"
  }, {
    path: "/corporate",
    component: _5651ac6b,
    children: [{
      path: "",
      component: _7567f6ae,
      name: "kurumsal-index___en"
    }, {
      path: "/corporate/about",
      component: _6b11f13f,
      name: "kurumsal-index-hakkimizda___en"
    }, {
      path: "/corporate/career",
      component: _6a0241d6,
      name: "kurumsal-index-kariyer___en"
    }, {
      path: "/corporate/community-rules",
      component: _72f44c4a,
      name: "kurumsal-index-topluluk-kurallari___en"
    }, {
      path: "/corporate/contact",
      component: _3d0353b4,
      name: "kurumsal-index-iletisim___en"
    }, {
      path: "/corporate/masthead",
      component: _b1a6e5a8,
      name: "kurumsal-index-kunye___en"
    }, {
      path: "/corporate/privacy-policy",
      component: _3b3b3126,
      name: "kurumsal-index-gizlilik-politikasi___en"
    }, {
      path: "/corporate/publication-principles",
      component: _949d43d0,
      name: "kurumsal-index-yayin-ilkeleri___en"
    }, {
      path: "/corporate/user-agreement",
      component: _8d0f2c5a,
      name: "kurumsal-index-kullanici-sozlesmesi___en"
    }]
  }, {
    path: "/emojile",
    component: _fb14c2f0,
    name: "emojile___en"
  }, {
    path: "/game",
    component: _eeebcba0,
    name: "oyun___en"
  }, {
    path: "/kesfet",
    component: _7a815b09,
    name: "kesfet___en"
  }, {
    path: "/message",
    component: _826bda66,
    name: "mesaj___en"
  }, {
    path: "/notifications",
    component: _2f01bfd6,
    name: "bildirimler___en"
  }, {
    path: "/r",
    component: _fcbd9d0a,
    name: "r___en"
  }, {
    path: "/rss",
    component: _34850b58,
    name: "rss___en"
  }, {
    path: "/sanaozel",
    component: _0a46f700,
    name: "sanaozel___en"
  }, {
    path: "/search",
    component: _646feb4e,
    name: "ara___en"
  }, {
    path: "/settings",
    component: _03d1d2c6,
    name: "ayarlar___en"
  }, {
    path: "/trendler",
    component: _ec63496e,
    name: "trendler___en"
  }, {
    path: "/tumicerikler",
    component: _3364af31,
    name: "tumicerikler___en"
  }, {
    path: "/vitrin",
    component: _44a00943,
    name: "vitrin___en"
  }, {
    path: "/yazio",
    component: _1935bda1,
    name: "yazio___en"
  }, {
    path: "/zekiye",
    component: _4f2293c2,
    name: "zekiye___en"
  }, {
    path: "/astroloji/burc-uyumu-hesaplama",
    component: _0f75c1a8,
    name: "astroloji-burc-uyumu-hesaplama___en"
  }, {
    path: "/astroloji/dogum-haritasi-hesaplama",
    component: _4e0343f0,
    name: "astroloji-dogum-haritasi-hesaplama___en"
  }, {
    path: "/astroloji/yukselen-burc-hesaplama",
    component: _388f3e59,
    name: "astroloji-yukselen-burc-hesaplama___en"
  }, {
    path: "/aydinlatma-metni/calisan-adayi",
    component: _9d410026,
    name: "aydinlatma-metni-calisan-adayi___en"
  }, {
    path: "/aydinlatma-metni/fiziki-ziyaretci",
    component: _3fb3d99c,
    name: "aydinlatma-metni-fiziki-ziyaretci___en"
  }, {
    path: "/aydinlatma-metni/ilgili-kisi-basvuru-formu",
    component: _1445949a,
    name: "aydinlatma-metni-ilgili-kisi-basvuru-formu___en"
  }, {
    path: "/aydinlatma-metni/musteri-adayi",
    component: _3019357b,
    name: "aydinlatma-metni-musteri-adayi___en"
  }, {
    path: "/aydinlatma-metni/uye-ziyaretci",
    component: _2447d5ea,
    name: "aydinlatma-metni-uye-ziyaretci___en"
  }, {
    path: "/dev/counter",
    component: _2249dd08,
    name: "dev-counter___en"
  }, {
    path: "/dev/reco",
    component: _27dd0703,
    name: "dev-reco___en"
  }, {
    path: "/haber/yarat",
    component: _40a5bbca,
    name: "haber-yarat___en"
  }, {
    path: "/mobile/bilpop",
    component: _26c0b582,
    name: "mobile-bilpop___en"
  }, {
    path: "/mobile/emojile",
    component: _435cb13c,
    name: "mobile-emojile___en"
  }, {
    path: "/settings/blocked-accounts",
    component: _bc625412,
    name: "ayarlar-engellenen-hesaplar___en"
  }, {
    path: "/settings/change-password",
    component: _041c4ebc,
    name: "ayarlar-sifre-degistir___en"
  }, {
    path: "/settings/deactivate-account",
    component: _f3fac482,
    name: "ayarlar-hesap-dondurma___en"
  }, {
    path: "/settings/delete-account",
    component: _d2f0c71e,
    name: "ayarlar-hesap-silme___en"
  }, {
    path: "/astroloji/dogum-haritasi-hesaplama/sonuc",
    component: _36afcdd6,
    name: "astroloji-dogum-haritasi-hesaplama-sonuc___en"
  }, {
    path: "/astroloji/tarot/tarot-kartlari-ve-anlamlari",
    component: _09696e1c,
    name: "astroloji-tarot-tarot-kartlari-ve-anlamlari___en"
  }, {
    path: "/astroloji/yukselen-burc-hesaplama/sonuc",
    component: _d37ea3b2,
    name: "astroloji-yukselen-burc-hesaplama-sonuc___en"
  }, {
    path: "/auth/twitter/callback",
    component: _89c8af24,
    name: "auth-twitter-callback___en"
  }, {
    path: "/embed/widget/leaderboard",
    component: _466469dc,
    name: "embed-widget-leaderboard___en"
  }, {
    path: "/mobile/oyun/leaderboard/:slug?",
    component: _304bc57f,
    name: "mobile-oyun-leaderboard-slug___en"
  }, {
    path: "/mobile/oyun/skor/:slug?",
    component: _6ddd5cbf,
    name: "mobile-oyun-skor-slug___en"
  }, {
    path: "/astroloji/tarot/:slug",
    component: _3db57f00,
    name: "astroloji-tarot-slug___en"
  }, {
    path: "/auth/delete-account/:slug?",
    component: _21f42f93,
    name: "auth-delete-account-slug___en"
  }, {
    path: "/auth/forgot-password/:slug?",
    component: _b0f27e7a,
    name: "auth-forgot-password-slug___en"
  }, {
    path: "/auth/reset-password/:slug?",
    component: _0bc6f761,
    name: "auth-reset-password-slug___en"
  }, {
    path: "/auth/verify-email/:slug?",
    component: _b7529c60,
    name: "auth-verify-email-slug___en"
  }, {
    path: "/business/business-life/:subOrPagination?",
    component: _547b82d2,
    name: "/business/business-life___en"
  }, {
    path: "/business/economy/:subOrPagination?",
    component: _547b82d2,
    name: "/business/economy___en"
  }, {
    path: "/business/enterpreneurship/:subOrPagination?",
    component: _547b82d2,
    name: "/business/enterpreneurship___en"
  }, {
    path: "/culture/art/:subOrPagination?",
    component: _547b82d2,
    name: "/culture/art___en"
  }, {
    path: "/culture/cinema/:subOrPagination?",
    component: _547b82d2,
    name: "/culture/cinema___en"
  }, {
    path: "/culture/history/:subOrPagination?",
    component: _547b82d2,
    name: "/culture/history___en"
  }, {
    path: "/culture/literature/:subOrPagination?",
    component: _547b82d2,
    name: "/culture/literature___en"
  }, {
    path: "/culture/painting/:subOrPagination?",
    component: _547b82d2,
    name: "/culture/painting___en"
  }, {
    path: "/culture/photography/:subOrPagination?",
    component: _547b82d2,
    name: "/culture/photography___en"
  }, {
    path: "/culture/theather/:subOrPagination?",
    component: _547b82d2,
    name: "/culture/theather___en"
  }, {
    path: "/entertainment/astrology/:subOrPagination?",
    component: _547b82d2,
    name: "/entertainment/astrology___en"
  }, {
    path: "/entertainment/celebrities/:subOrPagination?",
    component: _547b82d2,
    name: "/entertainment/celebrities___en"
  }, {
    path: "/entertainment/fashion/:subOrPagination?",
    component: _547b82d2,
    name: "/entertainment/fashion___en"
  }, {
    path: "/entertainment/games/:subOrPagination?",
    component: _547b82d2,
    name: "/entertainment/games___en"
  }, {
    path: "/entertainment/music/:subOrPagination?",
    component: _547b82d2,
    name: "/entertainment/music___en"
  }, {
    path: "/entertainment/tv/:subOrPagination?",
    component: _547b82d2,
    name: "/entertainment/tv___en"
  }, {
    path: "/life/animals/:subOrPagination?",
    component: _547b82d2,
    name: "/life/animals___en"
  }, {
    path: "/life/beauty/:subOrPagination?",
    component: _547b82d2,
    name: "/life/beauty___en"
  }, {
    path: "/life/decoration/:subOrPagination?",
    component: _547b82d2,
    name: "/life/decoration___en"
  }, {
    path: "/life/family/:subOrPagination?",
    component: _547b82d2,
    name: "/life/family___en"
  }, {
    path: "/life/food/:subOrPagination?",
    component: _547b82d2,
    name: "/life/food___en"
  }, {
    path: "/life/health/:subOrPagination?",
    component: _547b82d2,
    name: "/life/health___en"
  }, {
    path: "/life/nature/:subOrPagination?",
    component: _547b82d2,
    name: "/life/nature___en"
  }, {
    path: "/life/relations/:subOrPagination?",
    component: _547b82d2,
    name: "/life/relations___en"
  }, {
    path: "/life/travel/:subOrPagination?",
    component: _547b82d2,
    name: "/life/travel___en"
  }, {
    path: "/onedio/funny/:subOrPagination?",
    component: _547b82d2,
    name: "/onedio/funny___en"
  }, {
    path: "/onedio/listicle/:subOrPagination?",
    component: _547b82d2,
    name: "/onedio/listicle___en"
  }, {
    path: "/onedio/men/:subOrPagination?",
    component: _547b82d2,
    name: "/onedio/men___en"
  }, {
    path: "/onedio/quiz/:subOrPagination?",
    component: _547b82d2,
    name: "/onedio/quiz___en"
  }, {
    path: "/onedio/video/:subOrPagination?",
    component: _547b82d2,
    name: "/onedio/video___en"
  }, {
    path: "/onedio/women/:subOrPagination?",
    component: _547b82d2,
    name: "/onedio/women___en"
  }, {
    path: "/oyun/leaderboard/:slug?",
    component: _0611b3d6,
    name: "oyun-leaderboard-slug___en"
  }, {
    path: "/oyun/skor/:slug?",
    component: _c30a5b70,
    name: "oyun-skor-slug___en"
  }, {
    path: "/search/content/:slug?",
    component: _c08fb810,
    name: "ara-haber-slug___en"
  }, {
    path: "/search/tag/:slug?",
    component: _db0c8cf8,
    name: "ara-etiket-slug___en"
  }, {
    path: "/search/user/:slug?",
    component: _3ffd4743,
    name: "ara-uye-slug___en"
  }, {
    path: "/sport/basketball/:subOrPagination?",
    component: _547b82d2,
    name: "/sport/basketball___en"
  }, {
    path: "/sport/football/:subOrPagination?",
    component: _547b82d2,
    name: "/sport/football___en"
  }, {
    path: "/sport/others/:subOrPagination?",
    component: _547b82d2,
    name: "/sport/others___en"
  }, {
    path: "/technology/automobile/:subOrPagination?",
    component: _547b82d2,
    name: "/technology/automobile___en"
  }, {
    path: "/technology/devices/:subOrPagination?",
    component: _547b82d2,
    name: "/technology/devices___en"
  }, {
    path: "/technology/game/:subOrPagination?",
    component: _547b82d2,
    name: "/technology/game___en"
  }, {
    path: "/technology/internet/:subOrPagination?",
    component: _547b82d2,
    name: "/technology/internet___en"
  }, {
    path: "/technology/mobile/:subOrPagination?",
    component: _547b82d2,
    name: "/technology/mobile___en"
  }, {
    path: "/technology/science/:subOrPagination?",
    component: _547b82d2,
    name: "/technology/science___en"
  }, {
    path: "/technology/space/:subOrPagination?",
    component: _547b82d2,
    name: "/technology/space___en"
  }, {
    path: "/astroloji/tarot/:slug?/:card",
    component: _72beb39d,
    name: "astroloji-tarot-slug-card___en"
  }, {
    path: "/*-news/:pageNum?",
    component: _3c773672
  }, {
    path: "/akis/:slug?",
    component: _a4a8570e,
    name: "akis-slug___en"
  }, {
    path: "/amp-haber/:slug?",
    component: _80a200a4,
    name: "amp-haber-slug___en"
  }, {
    path: "/business/:subOrPagination?",
    component: _547b82d2,
    name: "/business___en"
  }, {
    path: "/content/:slug?",
    component: _638bf4b7,
    name: "haber-slug___en"
  }, {
    path: "/culture/:subOrPagination?",
    component: _547b82d2,
    name: "/culture___en"
  }, {
    path: "/entertainment/:subOrPagination?",
    component: _547b82d2,
    name: "/entertainment___en"
  }, {
    path: "/game/:slug?",
    component: _f2590e30,
    name: "oyun-slug___en"
  }, {
    path: "/h/:slug?",
    component: _a208d6ae,
    name: "h-slug___en"
  }, {
    path: "/instagram/:slug?",
    component: _2a2b3973,
    name: "instagram-slug___en"
  }, {
    path: "/life/:subOrPagination?",
    component: _547b82d2,
    name: "/life___en"
  }, {
    path: "/news/:subOrPagination?",
    component: _547b82d2,
    name: "/news___en"
  }, {
    path: "/onedio/:subOrPagination?",
    component: _547b82d2,
    name: "/onedio___en"
  }, {
    path: "/other/:subOrPagination?",
    component: _547b82d2,
    name: "/other___en"
  }, {
    path: "/profile/:username",
    component: _6264ec8f,
    name: "profil-username___en",
    children: [{
      path: "icerikler",
      component: _0f3c3a60,
      name: "profil-username-index-icerikler___en"
    }, {
      path: "/profile/:username/comments",
      component: _228c5d19,
      name: "profil-username-index-yorumlar___en"
    }, {
      path: "/profile/:username/favorites",
      component: _eb22c564,
      name: "profil-username-index-favoriler___en"
    }, {
      path: "/profile/:username/followers",
      component: _1170ecfe,
      name: "profil-username-index-takipciler___en"
    }, {
      path: "/profile/:username/followings",
      component: _5b304122,
      name: "profil-username-index-takip-ettikleri___en"
    }]
  }, {
    path: "/search/:slug?",
    component: _67dd2dde,
    name: "ara-slug___en"
  }, {
    path: "/sport/:subOrPagination?",
    component: _547b82d2,
    name: "/sport___en"
  }, {
    path: "/technology/:subOrPagination?",
    component: _547b82d2,
    name: "/technology___en"
  }, {
    path: "/uye/:slug?",
    component: _1087887c,
    name: "uye-slug___en"
  }, {
    path: "/yazio/:slug",
    component: _177f1c59,
    name: "yazio-slug___en"
  }, {
    path: "/mobile/:slug?/view",
    component: _5778039d,
    name: "mobile-slug-view___en"
  }, {
    path: "/profile/:username/settings",
    component: _cb375fde,
    name: "profil-username-ayarlar___en"
  }, {
    path: "/astroloji/:burc?/:slug?",
    component: _2a849156,
    name: "astroloji-burc-slug___en"
  }, {
    path: "/message/:username/:slug?",
    component: _3e48db2a,
    name: "mesaj-username-slug___en"
  }, {
    path: "/vitrin/:slug/:pageNum?",
    component: _16ef6b7c,
    name: "vitrin-slug-pageNum___en"
  }, {
    path: "/tag/:tagName/:tagId/:pageNum?",
    component: _5c8fd7fd,
    name: "etiket-tagName-tagId-pageNum___en"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
